<template>
    <div class="review-container">
        <Loading v-if="checkingConfiguration" class="loading-container" :message="loadingMessage"></Loading>
        <div v-if="!checkingConfiguration" class="review">
            <FeatureReview :configurationWrapper="templateConfiguration" :configurationName="'Selected Template'"/>
            <FeatureReview :configurationWrapper="projectConfiguration.name" :configurationName="'Project Name'"/>
            <FeatureReview :configurationWrapper="projectConfiguration.port" :configurationName="'Port'" v-if="projectConfiguration.template.value == 'MICROSERVICE'"/>
            <FeatureReview :configurationWrapper="hostConfiguration" :configurationName="'Host'" v-if="projectConfiguration.template.value == 'MICROSERVICE'"/>
            <FeatureReview :configurationWrapper="generateStarterConfiguration" :configurationName="'Generate Starter'" v-if="projectConfiguration.template.value == 'UTIL'"/>
            <FeatureReview :configurationWrapper="generateStandaloneConfiguration" :configurationName="'Generate Standalone'" v-if="projectConfiguration.template.value == 'UTIL'"/>
        </div>
        <v-row v-if="!checkingConfiguration">
            <v-spacer/>
            <v-btn v-on:click="editConfiguration" class="send-btn ma-4 justify-end" :color="proceedable ? '#e7a34d' : '#b00020'" dark large>
                Edit Configuration
                <v-icon right>mdi-pencil</v-icon>
            </v-btn>
            <v-btn  v-if="proceedable" v-on:click="generateApplication" class="send-btn ma-4 justify-end" color="#42b983" dark large>
                Generate Application
                <v-icon right>mdi-settings-transfer</v-icon>
            </v-btn>
        </v-row>
    </div>
</template>

<script>

    import PacmanLoader from "../general/PacmanLoader";
    import FeatureReview from "./FeatureReview";

    export default {
        name: 'ConfigurationReview',
        components: {
            FeatureReview: FeatureReview,
            Loading: PacmanLoader
        },
        data: () => {
            return {
                loadingMessage: "Processing Request..."
            }
        },
        methods: {
            editConfiguration: function () {
                this.$emit('editConfiguration');
            },
            generateApplication: function () {
                this.$emit('generateApplication');
            }
        },
        props: [
            'projectConfiguration',
            'checkingConfiguration'
        ],
        computed: {
            hostConfiguration: function () {
                return {
                    value: this.projectConfiguration.host.displayName,
                    state: this.projectConfiguration.host.state,
                    messages: this.projectConfiguration.host.messages
                }
            },
            generateStarterConfiguration: function () {
                return {
                    value: this.projectConfiguration.generateStarter.displayName,
                    state: this.projectConfiguration.generateStarter.state,
                    messages: this.projectConfiguration.generateStarter.messages
                }
            },
            generateStandaloneConfiguration: function () {
                return {
                    value: this.projectConfiguration.generateStandalone.displayName,
                    state: this.projectConfiguration.generateStandalone.state,
                    messages: this.projectConfiguration.generateStandalone.messages
                }
            },
            templateConfiguration: function () {
                return {
                    value: this.projectConfiguration.template.displayName,
                    state: this.projectConfiguration.template.state,
                    messages: this.projectConfiguration.template.messages
                }
            },
            proceedable: function () {
                return this.projectConfiguration.state === 'NEEDS_CONFIRMATION' || this.projectConfiguration.state === 'SUCCESS'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

    .loading-container {
        margin-top: 150px;
    }

    .review {
        padding: 0 10%;
        margin-top: 50px;
    }

    .review-container .review .card-container {
        padding: 0 !important;
    }

    .review-container .review .feature-review-container:last-child .card-container {
        padding-top: 0px !important;
        padding-bottom: 25px !important;
    }

</style>
